import React, {useState, useEffect, useCallback } from "react";
import MaterialSwatch from "./MaterialSwatch";
import Materials from '../collections/materials'
import GetKeyByValue from '../utils/getKeyByValue'
import ShuffleUndo from '../utils/ShuffleUndo'
import UndoRedo from '../utils/undoRedo'
import {  Grid,} from "@material-ui/core";

let zmatPrim 
let zmatSec
let woodMatList
let greenMatList
let tileMatList
let industryMatList 

    zmatPrim ="Solanum Steel" 
    zmatSec = "Star Blue Copper"
    woodMatList = "Walnut"
    greenMatList ="Dewey Panic Grass"
    tileMatList = "Marble"
    industryMatList = "Concrete"



let objUndoRedo = UndoRedo()


const asyncUrl = async (evt) => {
  const evtObj = await evt

  const urlParamsParent =   new URLSearchParams(evtObj.origin + '/' + evtObj.data)
  return  urlParamsParent
}

export default function MaterialMenu(props) {
  const { material, setMaterial, setMatScene, asyncLogParams, setUrlConfig } = props;

  const [LockStatus, setLockStatus] = useState({
    zPrime: false,
    ZSec: false,
    wood: false,
    nature: false,
    tile: false,
    industrial: false,
  });
  const [resetLock, setResetLock] = useState(false);

  useEffect(() => {
    setLockStatus(LockStatus)
   }, [LockStatus])

  
  // start URL parsing
  useEffect(() => { // on first load, see if there is a string to grab
    const urlParams = new URLSearchParams(window.location.search)
    
    // const parentURL = window.parent.location;


    function displayMessage (evt) {
      console.log('evt.origin', evt.origin, evt.data)
      if (evt.data ){
        // const urlParamsParent =  new URLSearchParams(evt.origin + '/' + evt.data)
        const urlParamsParent =  asyncUrl(evt)

        // console.log('urlParamsParent', urlParamsParent, urlParamsParent.get('session'))
        
        console.log('window.location !== window.parent.location', window.location, window.parent.location)

        if(window.location !== window.parent.location){
          // console.log("urlParamsParent.has('session')",urlParamsParent.has('session'))
          // if (urlParamsParent.has('session')) {
            // const parsUrls = urlParamsParent.get('session') 
            const parsUrls = evt.data 
            if (parsUrls.includes('session')){
              
              parsUrls.replaceAll('?session=','')
              console.log('parsUrls', parsUrls)
              
              const tempList = parsUrls.split('_')
              const splitList1 = tempList.map(val => val.replaceAll('-', ' '))
              const splitList2 = splitList1.map(val => val.replaceAll('?session=',''))
              const splitList3 = splitList2.map(val => val.replaceAll('?&session=',''))
              const splitList = splitList3.map(val => val.replaceAll('',''))
              console.log('splitList', splitList)
              
              setMaterial({
                zPrime: splitList[0],
                ZSec: splitList[1],
                wood: splitList[2],
                nature: splitList[3],
                tile: splitList[4],
                industrial: splitList[5],
              })
          }
          // }
        }
      }
    }

    window.addEventListener('message', function(event) {
      console.log('message', event)
      displayMessage(event)
    })
    
    

    //Parse url
    if (urlParams.has('session')) {
      console.log("url+", urlParams.get('session') )
      console.log("url+", urlParams)

      const parsUrls = urlParams.get('session') 
      const tempList = parsUrls.split('_')
      const splitList = tempList.map(val => val.replaceAll('-', ' '))
      
      // console.log("url+1", splitList)
      setMaterial({
        zPrime: splitList[0],
        ZSec: splitList[1],
        wood: splitList[2],
        nature: splitList[3],
        tile: splitList[4],
        industrial: splitList[5],
      })
    }
  
  // }, [setMaterial])
  }, [])

  useEffect(() => { // each action of updating page should update url
    // update url with new link
    const parentWindow = window.parent

    const temp = Object.values(material)
    const temp2 = temp.map(val => val.replaceAll(' ', '-'))
    const stringer = temp2.join('_')
    let baseUrl 
    let downloadURL
    const getUrlHost = window.location.hostname

    if(window.location != window.parent.location){

      parentWindow.postMessage(stringer, '*')
      downloadURL =  'https://www.azahner.com/labs/materialcomposer/?session=' + stringer

    } else {

      if(getUrlHost === 'localhost'){
        // console.log("localhost")
        baseUrl = 'http://localhost:3000'
      }else if(getUrlHost === 'materialcomposer.web.app'){
        // console.log("web.app")
        baseUrl = 'https://materialcomposer.web.app'
      }else if(getUrlHost === 'https://www.azahner.com/'){
        // console.log("web.app")
        baseUrl = 'https://www.azahner.com/labs/materialcomposer'

      }
      window.history.replaceState("","",`${baseUrl}/?session=${stringer}`)

      downloadURL = `${baseUrl}/?session=${stringer}`
      
    }
    setUrlConfig(downloadURL)


  }, [material])

  //undo 
  const [RedoTrigger, setRedoTrigger ] = useState(false)
  const [UndoTrigger, setUndoTrigger ] = useState(false)
  const [mousOnMaterials, setmousOnMaterials ] = useState(false)


  useEffect(() => {
    // console.log('init mat change', material)
    objUndoRedo.initPosition()
    objUndoRedo.setValue(material)
    // shuffleFuncStart()
  }, [])

  if (UndoTrigger) {
    // console.log('undo inside Mat', objUndoRedo.position, objUndoRedo.value() )
    
    objUndoRedo.undo()
    setMaterial(objUndoRedo.value())
    // console.log('undo inside Mat2', objUndoRedo.value() )
    setUndoTrigger(false)
    setResetLock(true)
    setLockStatus({zPrime: false,
    ZSec: false,
    wood: false,
    nature: false,
    tile: false,
    industrial: false,
    })
  }

  if (RedoTrigger) {
    // console.log('Redo inside Mat' )
    objUndoRedo.redo()
    setMaterial(objUndoRedo.value())
    setRedoTrigger(false)
  }

  

  const handleClick = (event) => {
    let eventTarget = event.currentTarget.children[0].id

    
    LockStatus[eventTarget]? 
        setLockStatus(prevState => ({
          ...prevState, 
          [eventTarget]: false
        })) 
        : setLockStatus(prevState => ({
          ...prevState, 
          [eventTarget]: true
        }))
    LockStatus[eventTarget]? 
      setLockStatus(prevState => ({
        ...prevState, 
        [eventTarget]: false
      })) 
      : setLockStatus(prevState => ({
        ...prevState, 
        [eventTarget]: true
      }))
    asyncLogParams('locked-Material', material[eventTarget])
    // console.log("event LockStatus", LockStatus)
  };


  
  const getRandomMaterial = (matString) => {
    
    return Materials.filter(v => v.material === matString).map(choice => choice.name).sort(() => Math.random() - 0.5)[0]
  }
 

  const randomMaterial =  () => {
    // console.log('woodMatList', woodMatList)
  
    zmatPrim = LockStatus.zPrime? zmatPrim : getRandomMaterial("zahner")
    zmatSec = LockStatus.ZSec? zmatSec : getRandomMaterial("zahner")
    woodMatList = LockStatus.wood? woodMatList : getRandomMaterial("wood")
    greenMatList = LockStatus.nature? greenMatList : getRandomMaterial("nature")
    tileMatList = LockStatus.tile? tileMatList : getRandomMaterial("tile")
    industryMatList = LockStatus.industrial? industryMatList: getRandomMaterial("industrial")
  }
    



  const eventSpacebarTestDown = useCallback ((event) => {
    


    if (event.code === 'Space') {
      event.preventDefault()
        shuffleFuncCall()
        
    }
  })
   
    
  const ctrZ = (event) => {

    if (event.keyCode === 90 && event.ctrlKey ) {
      event.preventDefault()

      if (objUndoRedo.value() !== 'undefined'){
        objUndoRedo.undo()
        setMaterial(objUndoRedo.value())

      }
    }
  }

  const ctrY = (event) => {

    if (event.keyCode === 89 && event.ctrlKey ) {
      event.preventDefault()

      if (objUndoRedo.value() !== 'undefined'){
        objUndoRedo.redo()
        setMaterial(objUndoRedo.value())
      }
    }
  }

  useEffect(() => {
  
    window.addEventListener('keydown', eventSpacebarTestDown)    
    window.addEventListener('keydown', ctrZ)    
    window.addEventListener('keydown', ctrY)    
    // document.addEventListener('onkeydown', ctrY)  

    return () => {
      window.removeEventListener('keydown', eventSpacebarTestDown)
      window.removeEventListener('keydown', ctrZ)    
      window.removeEventListener('keydown', ctrY)    
    }
  },[LockStatus]);
  // },[]);
  // const shuffleFuncStart = () => {
  //   // setmaterialStore(materialArray)
  //   randomMaterial();
  //   setMaterial({
  //     zPrime: zmatPrim,
  //     ZSec: zmatSec,
  //     wood: woodMatList,
  //     nature: greenMatList,
  //     tile: tileMatList,
  //     industrial: industryMatList,
  //   })
  //   objUndoRedo.setValue(material)
  //   setMatScene(true)
  // }
  
  const shuffleFunc = () => {
    // setmaterialStore(materialArray)
    // setLockStatus(prevState => ({...prevState})) 
    // setLockStatus(LockStatus) 
    randomMaterial();
    setMaterial({
      zPrime: zmatPrim,
      ZSec: zmatSec,
      wood: woodMatList,
      nature: greenMatList,
      tile: tileMatList,
      industrial: industryMatList,
    })
    objUndoRedo.setValue(material)
    setMatScene(true)
    asyncLogParams('Shuffled', 1) // need to move here to get called by both spacevent and button
    // console.log('shuffle')
  }
  
  const shuffleFuncCall = () => {
    
    shuffleFunc()
    
    // console.log('shuffle space event call', LockStatus)
  }

  const menuItems = Object.values(material).map((choice, idx) => (
    // console.log("MaterialMenu", choice)
    

      <div key={idx} onClick={handleClick}
      >
        <MaterialSwatch 
        key={idx}
        keys={GetKeyByValue(material, choice)}
        name={Materials.filter(v => v.name === choice)[0].name}
        source={Materials.filter(v => v.name === choice)[0].imageUrl.default} 
        idx={idx} 
        setMaterial={setMaterial}
        material={material}
        // matKey={matKey}
        setLockStatus={setLockStatus}
        mousOnMaterials={mousOnMaterials}
        resetLock={resetLock}
        setResetLock={setResetLock}
        />
      </div>
    )
    )


  return (
    
    <div >
        <Grid  container 
            
            flexgrow = {1}
            style={{padding: '10px',}}
            onMouseEnter={() => setmousOnMaterials(true)}
            onMouseLeave={() => setmousOnMaterials(false)}
            >


              {menuItems}  

              <div style={{borderLeft: '2px solid grey',  height: 'auto'}}></div>

              <ShuffleUndo key='shuff' shuffleFunc={shuffleFunc} setUndoTrigger={setUndoTrigger} setRedoTrigger={setRedoTrigger}/>

        </Grid>
    </div>
    
  );

}
